import React, { useEffect, useState } from "react";
import {
  fetchBuOptions,
  getDeptUsers,
  getNamesofAgreement,
} from "../apis/userApis";
import {
  ActionIcon,
  Badge,
  Button,
  Input,
  Modal,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import TablePagination from "../componenets/Common/TablePagination";
import UniversalTable from "../componenets/Common/UniversalTable";
import {
  excelDownload,
  getComplianceBadgeColor,
  getDateStatus,
  getDepartmentText,
  getStatusColor,
  getStatusText,
  infoColor,
} from "./utilities";
import {
  IconEye,
  IconHistory,
  IconInfoCircle,
  IconSortAscending,
  IconSortDescending,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { getAllObligations, getTitlesApi } from "../apis/obligationApi";
import { departmentData } from "./utilities";
import { DatePicker } from "@mantine/dates";
import { getCookiesSession } from "../apis/cookiesSession";

const CompletedObligation = () => {
  const userData = JSON.parse(getCookiesSession("userData") || "{}");
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const navigate = useNavigate();
  let filterForUser = {
    compliant: null,
    department:
      userData.loginAs === "Ob-CXO" || userData.loginAs === "Ob-DeptAdmin"
        ? userData.activeDepartment
        : null,
    businessUnit: userData.loginAs === "Ob-COO" ? userData.businessUnit : null,
    extraCol1: null,
    assignToId: null,
    joOrder: null,
    duedate: null,
  };
  const [filters, setFilters] = useState(filterForUser);
  const [configs, setConfigs] = useState({
    loading: true,
    obligations: null,
    count: 0,
  });
  const [buData, setBuData] = useState(null);

  const [categoryOptions, setCategoryOptions] = useState([
    "NDA",
    "Service Agreement",
  ]);

  useEffect(() => {
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getNames();
  }, []);
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      setBuData(response.buData);
    };
    getBuData();
  }, []);
  const [applyfilters, setApplyFilters] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [partyName, setPartyName] = useState("");
  const [status, setStatus] = useState(null);
  const [assignToData, setAssignToData] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [csvData, setCsvData] = useState([]);
  let sr = (page - 1) * pageSize + 1;
  const [sortByOptions, setSortByOptions] = useState({
    key: "duedate",
    value: "asc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };
  useEffect(() => {
    const getObligation = async () => {
      const filterdata = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== null)
      );
      const sortOption = { [sortByOptions.key]: sortByOptions.value };
      const response = await getAllObligations({
        page: page,
        partyName: partyName,
        filters: filterdata,
        pageSize,
        status,
        sortByOptions: sortOption,
      });
      setConfigs({
        loading: false,
        obligations: response.obligations,
        count: response.count,
      });
      setCsvData(response.exportData)
      console.log("response: ", response);
    };
    getObligation();
    const getassignToUsers = async () => {
      const response = await getDeptUsers();
      setAssignToData(response.userData);
    };
    getassignToUsers();
    const getTitles = async () => {
      const response = await getTitlesApi();
      if (response.success) {
        setTitleOptions(response.titles);
      }
    };
    getTitles();
  }, [page, applyfilters, pageSize, sortByOptions]);
  const onExport = async () => {
      if (csvData.length > 0) {
        const columnHeaders = Object.keys(csvData[0]);
        excelDownload({
          data: csvData,
          headers: columnHeaders,
          name: "obligation_monitor",
        });
      }
    };
  const onViewClick = ({ id }) => {
    window.open(`/viewobligation/${id}`, '_blank');
  };
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID

  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };

  return (
    <>
      {/* <Text className="font-semibold text-xl m-4">obligations monitor</Text> */}

      <div className="grid grid-cols-6 gap-4 m-4">
        <Select
          placeholder="select compliance"
          label="compliance"
          value={filters.compliant}
          data={[
            { label: "upcoming", value: "upcoming" },
            {label: "due", value: "due"},
            { label: "non-compliant", value: "non-compliant" },
            {
              label: "partially-compliant",
              value: "partially-compliant",
            },
            { label: "compliant", value: "compliant" },
            {
              label: "delayed-compliant",
              value: "delayed-compliant",
            },
          ]}
          onChange={(val) => setFilters({ ...filters, compliant: val })}
        />
        <Select
          placeholder="select status"
          label="status"
          value={status}
          data={[
            { label: "upcoming", value: "upcoming" },
            {
              label: "due",
              value: "due",
            },
            { label: "overdue", value: "overdue" },
          ]}
          onChange={(val) => setStatus(val)}
        />
        {userData.loginAs !== "Ob-DeptAdmin" &&
        userData.loginAs !== "Ob-CXO" ? (
          <Select
            searchable
            label="department"
            placeholder="select department"
            data={departmentData}
            onChange={(val) => setFilters({ ...filters, department: val })}
            value={filters.department}
          />
        ) : (
          <Select
            searchable
            label="assigned to "
            data={assignToData}
            placeholder="assigned to"
            value={filters.assignToId}
            onChange={(val) => setFilters({ ...filters, assignToId: val })}
          />
        )}
        {buData !== null && userData.loginAs !== "Ob-COO" && (
          <Select
            searchable
            label="business unit"
            placeholder="select business unit"
            value={filters.businessUnit}
            data={buData}
            onChange={(val) => setFilters({ ...filters, businessUnit: val })}
          />
        )}
        <Select
          searchable
          label="Contract Category"
          placeholder="Contract Category"
          value={filters.extraCol1}
          data={categoryOptions}
          onChange={(val) => setFilters({ ...filters, extraCol1: val })}
        />
        <TextInput
          searchable
          label="second party name"
          placeholder="type party name"
          value={partyName}
          onChange={(e) => setPartyName(e.target.value)}
        />
        <TextInput
          label="job order"
          placeholder="job order"
          value={filters?.joOrder?.contains}
          onChange={(e) =>
            setFilters({
              ...filters,
              joOrder: { contains: e.target.value },
            })
          }
        />
        <Select
          searchable
          label="obligation title"
          placeholder="obligation title"
          data={titleOptions}
          value={filters.title}
          onChange={(val) => setFilters({ ...filters, title: val })}
        />
        <DatePicker
          label="due date start from"
          placeholder="start from"
          value={filters?.duedate?.gt}
          onChange={(val) =>
            setFilters({
              ...filters,
              duedate: { ...filters.duedate, gte: val },
            })
          }
        />
        <DatePicker
          label="due date till"
          placeholder="range end date"
          value={filters.duedate?.lte}
          onChange={(val) =>
            setFilters({
              ...filters,
              duedate: { ...filters.duedate, lte: val },
            })
          }
        />
      </div>
      <div className="m-4">
        <Button
          onClick={() => setApplyFilters(!applyfilters)}
          className="mr-4"
          variant="outline"
        >
          Search
        </Button>
        <Button
          onClick={() => {
            window.location.reload();
            // setFilters(filterForUser);
            // setPartyName("");
            // setStatus(null);
            // setApplyFilters(!applyfilters);
          }}
          color="#1b6f8d"
        >
          Clear
        </Button>
      </div>
      <div className="flex justify-end">
        <div className="flex">
          <Select
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "start date", value: "startDate" },
              { label: "due date", value: "duedate" },
              { label: "second party", value: "connectedParty" },
              { label: "id", value: "id" },
              { label: "brand name", value: "brandName" },
              { label: "title", value: "title" },
            ]}
          />

          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <IconSortAscending size={32} />
            ) : (
              <IconSortDescending size={32} />
            )}
          </ActionIcon>
        </div>
        <Button onClick={onExport}>Export</Button>
      </div>
      <div className="m-4">
        <>
          <UniversalTable
            headers={[
              {
                label: "id",
                align: "center",
                render: (row) => <Text size="sm">{row.id}</Text>,
              },
              {
                label: "title",
                align: "center",
                render: (row) => <Text size="sm" weight={600}>{row.title}</Text>,
              },
              {
                label: "description",
                align: "center",
                render: (row) => (
                  <div
                    style={{ cursor: "pointer", maxWidth: "250px" }}
                    onClick={() => handleExpand(row.id)}
                  >
                    <Text
                      size="sm"
                      color="dark.3"
                      lineClamp={expandedId === row.id ? undefined : 2}
                    >
                      {row.desc}
                    </Text>
                  </div>
                ),
              },
              {
                label: "job order",
                render: (row) => <Text size="sm">{row.joOrder || "--"}</Text>,
              },
              {
                label: "Contract Category",
                align: "center",
                render: (row) => <Text size="sm">{row.extraCol1 || "--"}</Text>,
              },
              {
                label: "second party",
                align: "center",
                render: (row) => (
                  <div>
                    <Text size="sm" weight={600}>{row.brandName}</Text>
                    <Text size="xs" c="dimmed">{"(" + row.connectedParty + ")"}</Text>
                  </div>
                ),
              },
              {
                label: "department",
                align: "center",
                render: (row) => <Text size="sm">{getDepartmentText(row.department)}</Text>,
              },
              {
                label: "assign to",
                align: "center",
                render: (row) => <Text size="sm">{row.assignTo?.name || "--"}</Text>,
              },
              {
                label: "status",
                render: (row) => {
                  const status = getDateStatus(row.startDate, row.duedate, row.reminderTime);
                  return (
                    <Badge variant="light" radius="xl" size="sm" color={getStatusColor(status)}>
                      {getStatusText(status)}
                    </Badge>
                  );
                },
              },
              {
                label: "compliance",
                align: "center",
                render: (row) => (
                  <Badge
                    variant="light"
                    radius="xl"
                    size="sm"
                    color={getComplianceBadgeColor(row.compliant)}
                  >
                    {row.compliant}
                  </Badge>
                ),
              },
              {
                label: "view",
                align: "center",
                render: (row) => (
                  <div className="flex flex-row justify-center gap-1">
                    <ActionIcon
                      onClick={() => onViewClick({ id: row.id })}
                      variant="subtle"
                      color="#1b6f8d"
                      radius="md"
                    >
                      <IconEye size={18} stroke={1.5} />
                    </ActionIcon>
                  </div>
                ),
              },
              {
                label: "history",
                align: "center",
                render: (row) => (
                  <ActionIcon
                    variant="subtle"
                    color="gray"
                    radius="md"
                    onClick={() => {
                      setAhId(row.id);
                      setAhModal(true);
                    }}
                  >
                    <IconHistory size={18} stroke={1.5} />
                  </ActionIcon>
                ),
              },
              {
                label: "",
                align: "center",
                render: (row) => (
                  <div className="flex flex-row justify-center gap-1">
                    {row.extraCol3 !== "" && (
                      <ActionIcon variant="subtle" radius="md">
                        <IconInfoCircle color={infoColor(row.extraCol3)} size={18} stroke={1.5} />
                      </ActionIcon>
                    )}
                  </div>
                ),
              },
            ]}
            data={configs.obligations}
            loading={configs.loading}
          />
          <TablePagination
            totalCount={configs.count}
            page={page}
            pageSize={pageSize}
            dataLength={configs.obligations?.length || 0}
            onPageChange={setPage}
            onPageSizeChange={(val) => {
              setPageSize(val);
              setPage(1);
            }}
          />
        </>
        <Modal
          opened={ahModal}
          onClose={() => {
            setAhModal(false);
            setAhId(0);
          }}
          title="oblligation action history"
          size="calc(80vw)"
        >
          <ObligationTranHistoryModal id={ahId} />
        </Modal>
      </div>
    </>
  );
};

export default CompletedObligation;
